<template>

    <div>


        <div class="alert alert-info" v-if="entries.length === 0"><h5 class="pt-2"><em>{{$t('text.globals.noOptions')}}</em></h5></div>

        <b-dropdown text="Izvoz" variant="primary" size="sm" class="float-right mt-2 mb-2" v-if="entries.length > 0 && $globalFunctions.checkForPermission('IZVOZ_REVIZ_SLED')">
            <template v-slot:button-content>
                <i class="fa fa-download"></i> {{$t('text.globals.export')}}
            </template>
            <b-dropdown-item @click="saveFile('json')" id="exportJson">{{$t('text.auditLogTable.auditLogExport.exportJson')}}</b-dropdown-item>
            <b-dropdown-item @click="saveFile('xml')" id="exportXml">{{$t('text.auditLogTable.auditLogExport.exportXML')}}</b-dropdown-item>
        </b-dropdown>


      <div class="table-responsive">
        <table class="table auditLogResults searchResults" v-if="entries.length > 0" style="min-width: 1100px">
          <thead>
          <tr>
            <th class="text-truncate" style="width: 35px;">#</th>
            <th class="text-truncate" style="width: 250px;">{{ $t('text.auditLogTable.time') }}</th>
            <th class="text-truncate" style="width: 150px;">{{ $t('text.classificationPlanMetadata.connectedSystem') }}</th>
            <th>{{ $t('text.auditLogTable.type') }}</th>
            <th>{{ $t('text.auditLogTable.itemLabel') }}</th>
            <th>{{ $t('text.auditLogTable.classLabel') }}</th>
            <th>{{ $t('text.auditLogTable.user') }}</th>
            <th>{{ $t('text.auditLogTable.role') }}</th>
            <th>{{ $t('text.auditLogTable.event') }}</th>
            <th class="text-truncate" style="width: 130px;">{{ $t('text.auditLogTable.details') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in entries">
            <td style="width: 35px;" class="text-muted">{{ index + 1 }}</td>
            <td style="width: 250px;">
              <!-- {{moment(item.createdAt).format('DD. MM. YYYY HH:mm:ss')}}-->
              {{ item.createdAt }}
            </td>
            <td style="width: 150px;">
              {{
                $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:oznaka_vpisnika',
                    item.externalSystemId)
              }}
            </td>
            <td>{{ item.values.type }}</td>
            <td>{{ item.values.ID }}</td>
            <td>{{ item.values.location }}</td>
            <td>
              {{ item.createdByUser.displayName }}
            </td>
            <td>
              {{ getRolesData(index) }}
            </td>
            <td>
              {{ item.values.event }}
            </td>
            <td style="width: 130px;">
              <a
                  class="btn btn-outline-info text-info btn-sm p-1 ml-2"
                  style="font-size: 12px" @click="showDetails(index)">{{ $t('text.auditLogTable.detailsLink') }}</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
        <div class="row" v-if="totalElements > 0">
            <div class="col-md-12">
                <b-pagination
                        class="list-inline mx-auto justify-content-center"
                        v-model="serverParams.pageNumber"
                        :total-rows="totalElements"
                        :per-page="serverParams.pageSize"
                        limit="10"
                        @change="$parent.onPageChange"
                >
                    <template v-slot:first-text><span><i
                            class="fas fa-fast-backward"></i></span></template>
                    <template v-slot:prev-text><span><i
                            class="fas fa-step-backward"></i></span></template>
                    <template v-slot:next-text><span><i
                            class="fas fa-step-forward"></i></span></template>
                    <template v-slot:last-text><span><i
                            class="fas fa-fast-forward"></i></span></template>
                </b-pagination>
            </div>
        </div>

        <b-modal ref="audit-details-modal" :title="$t('text.auditLogTable.auditDetailsModal.title')" size="xl">


            <div class="row">
                <div class="col-md-12 mb-0">


                    <div class="table-responsive" v-if="values.length > 20">
                        <table class="table auditLog" v-html="values"></table>
                    </div>
                    <div class="mt-2 mb-2 text-center" v-else>
                        <em><i class="fa fa-exclamation-triangle"></i>{{$t('text.auditLogTable.noDetailsAvailable')}}</em>
                    </div>

                </div>
            </div>


            <div slot="modal-footer" class="w-100">
                <b-button
                        id="headerCloseModalButton1"
                        variant="primary"
                        class="float-right"
                        @click="closeModal">
                    {{$t('text.globals.ok')}}
                </b-button>
            </div>

        </b-modal>
    </div>


</template>


<script>
    import Vue from 'vue';
    import {version} from '../../package';
    import $ from 'jquery';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import axios from 'axios';
    import JsonCSV from 'vue-json-csv';
    import flatten from 'flat';
    import jsonxml from 'jsontoxml';

    Vue.component('downloadCsv', JsonCSV)

    export default {
        name: 'AuditLogTable',
        components: {
            Loading,
            JsonCSV
        },
        props: ['entries', 'serverParams', 'totalElements'],
        data() {
            return {
                labelValues: [],
                values: [],
                selectedItemIndex: null,
                allMetadataOptions: [],

            };
        },
        computed: {

            getDataToExport() {
                const _this = this;

                let entriesToExport = _.map(_this.entries, function (val) {
                    if (val.values) {
                        return flatten(val)
                    }
                });


                console.log(entriesToExport);

                return entriesToExport;
            }
        },
        mounted() {
            const _this = this;

            console.log("pageable: ", this.pageable);

            let p1 = _this.$store.dispatch("retrieveAllMetadataOptions");

            Promise.all([p1]).then((values) => {
                _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;
            });

            _this.retrieveLabelValues();


        },
        methods: {

            saveFile(format) {

                let a;
                let e;
                let blob;

                if(format === 'json') {
                    const data = JSON.stringify(this.entries);
                    blob = new Blob([data], {type: 'text/plain'});
                    e = document.createEvent('MouseEvents');
                    a = document.createElement('a');
                    a.download = "izvoz_revizijske_sledi.json";
                    a.href = window.URL.createObjectURL(blob);
                    a.dataset.downloadurl = ['application/json', a.download, a.href].join(':');
                } else {
                    let xml = {items: []};
                    _.map(this.entries, function (val) {
                        xml.items.push(
                            {item: val}
                        )
                    });

                    const data = jsonxml(xml, {escape:true, removeIllegalNameCharacters:true});
                    blob = new Blob([data], {type: 'text/plain'});
                    e = document.createEvent('MouseEvents');
                    a = document.createElement('a');
                    a.download = "izvoz_revizijske_sledi.xml";
                    a.href = window.URL.createObjectURL(blob);
                    a.dataset.downloadurl = ['application/xml', a.download, a.href].join(':');
                }

                e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                a.dispatchEvent(e);
            },

            getRolesData(index) {
                const _this = this;

                let roles = ' ';

                _.map(_this.entries[index].values.role, function (val_inner, _index) {
                    roles += val_inner + (_index < _this.entries[index].values.role.length ? ', ' : '');
                });


                return roles
            },

            retrieveLabelValues() {
                const _this = this;

                axios.get(config.codeLists + 'audit-dictionary')
                    .then((res) => {

                        console.log("res", res);
                        _this.labelValues = res.data.body;

                    })
                    .catch((error) => {
                        console.error(error);
                    });

            },

            showDetails(index) {
                console.log(index);
                const _this = this;
                _this.selectedItemIndex = index;
                _this.getValues();
                _this.$refs['audit-details-modal'].show()
                // _this.$bvModal.show("audit-details-modal");
            },

            closeModal() {
                const _this = this;
                _this.selectedItemIndex = null;

                _this.$refs['audit-details-modal'].hide();
                // _this.$bvModal.hide('audit-details-modal');

            },

            getValues() {
                const _this = this;
                let values = _this.entries[_this.selectedItemIndex];
                _this.values = _this.objectToTable(values);
            },

            getReadableAuditKey(key) {
                const _this = this;

                let labelItem = _.filter(_this.labelValues, {key: key});

                if (labelItem.length) {
                    return labelItem[0].value
                } else {
                    return key
                }
            },

            objectToTable(obj) {
                const _this = this;

                let table = $('<table>').append('<tbody>');
                for (let key in obj) {
                    let tr = $('<tr>');
                    let th = $('<th>').append(_this.getReadableAuditKey(key));
                    let td = $('<td>');
                    let value;
                    if (typeof (obj[key]) == 'object') {
                        if (obj[key]) {
                            value = _this.objectToTable(obj[key]);
                        } else {
                            value = '<span class="null">null</span>';
                        }
                    } else if (typeof (obj[key]) == 'boolean') {
                        let str = (obj[key]) ? 'true' : 'false';
                        value = '<span class="boolean">' + str + '</span>';
                    } else if (typeof (obj[key]) == 'string') {

                        console.log("key", key);
                        console.log("obj[key]", obj[key]);

                        if (key === '/alfresco-access/transaction/sub-actions' || key === '/archeia/transaction/sub-actions') {
                            let subActionName = obj[key].split(' ');
                            let subActionReadableName = [];

                            _.map(subActionName, function (val) {
                                subActionReadableName.push(_this.getReadableAuditKey(val));
                            });

                            value = '<span class="string">"' + subActionReadableName.join(', ') + '"</span>';

                        } else {
                            value = '<span class="string">"' + _this.getReadableAuditKey(obj[key]) + '"</span>';
                        }

                    } else {
                        value = obj[key].valueOf();
                    }
                    td.append(value);
                    tr.append(th).append(td);
                    table.append(tr);
                }

                console.log("table", table);
                return '<table class="table">' + $(table).html() + '</table>';
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/AudiLogExternalTable.vue